import getValidSubmissions from '@/containers/E4ImpactMBA/helpers/getValidSubmissions';
import {COLORS} from '@/utils/constants';

const transformData = [
    {
        name: 'Never',
        value: 'NEVER_T',
    },
    {
        name: 'Sometimes',
        value: 'SOMETIMES_T',
    },
    {
        name: 'Yearly',
        value: 'YEARLY_T',
    },
    {
        name: 'Twice a year',
        value: 'TWICE A YEAR_T',
    },
    {
        name: 'Quarterly',
        value: 'QUARTERLY_T',
    }
];

/**
 * question: How often do you do bookkeeping for your business?
 * 
 * == baseline
 * bookkeeping_freq_t0
 * 
 * == final
 * bookkeeping_freq_t1
 * 
 * @param props 
 * @returns 
 */
export const levelImprovementChartCalculation = (props: any) => {
    const {filteredBaseline, filteredFinal} = getValidSubmissions(
        props.baselineSubmissions,
        props.finalSubmissions
    );
    
    const baselineData = transformData.map(({name, value}) => ({
        name,
        y: filteredBaseline.filter((submission: any) => submission.bookkeeping_freq_t0 === `${value}0`).length
    }));
    const finalData = transformData.map(({name, value}) => ({
        name,
        y: filteredFinal.filter((submission: any) => submission.bookkeeping_freq_t1 === `${value}1`).length
    }));
    
    return {
        chart: {
            type: 'line',
        },
        xAxis: {
            categories: transformData.map(({name}) => name),
        },
        legend: {
            verticalAlign: 'top',
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                },
            },
        },
        title: {
            text: '',
            align: 'left',
        },
        series: [
            {
                type: 'line',
                name: 'BASELINE',
                data: baselineData,
                color: COLORS.blue,
            },
            {
                type: 'line',
                name: 'FINAL',
                data: finalData,
                color: COLORS.yellow,
            },
        ],
    } as Highcharts.Options;
}